import { render, staticRenderFns } from "./stafans.vue?vue&type=template&id=43041c49&scoped=true"
import script from "./stafans.vue?vue&type=script&lang=js"
export * from "./stafans.vue?vue&type=script&lang=js"
import style0 from "./stafans.vue?vue&type=style&index=0&id=43041c49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43041c49",
  null
  
)

export default component.exports